import { getRealmByUrl } from 'portaltransparencia-common/libs/URLUtils';

export class KeycloakConfig {
  static config = () => {
    let url = 'https://openid.oxy.elotech.com.br/auth';

    if (window.location.hostname.includes('.qa.')) {
      url = 'https://openid.qa.elotech.com.br/auth';
    } else if (
      window.location.hostname.includes('.localnet') ||
      window.location.hostname.includes('localhost')
    ) {
      url = 'https://openid.dev.elotech.com.br/auth';
    }

    return {
      realm: getRealmByUrl(),
      url: url,
      resource: 'portal-transparencia-frontend',
      clientId: 'portal-transparencia-frontend',
      'ssl-required': 'none',
      'public-client': true,
      'confidential-port': 0,
      'enable-cors': true
    };
  };
}
